import { axiosInstance as axios } from 'Api'
import { handlingResponse } from 'Utility/globalMethods'
/* eslint-disable global-require */
if (process.env.ISMOCK) {
  require('Mocks/orderManagement/orderManagement')
}

export async function callGetOrders({ queryParams, headers }) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: `${process.env.PHOENIX_API}api/v1/orders`,
      headers, // tenantId, merchantId, roles
      params: queryParams
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function callGetOrderDetail({ urlParams, headers }) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: `${process.env.PHOENIX_API}api/v1/orders/${urlParams.orderId}`,
      headers
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function callRetrieveOrdersExportFile({ format, queryParams, headers }) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: `${process.env.PHOENIX_API}gateway/internal/orders/exports/${format}`,
      headers,
      params: queryParams,
      responseType: 'blob'
    })

    if (data.status === 400) {
      const promise = await data.data.text()
      return handlingResponse({ ...data, data: JSON.parse(promise) })
    }

    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
// @generator api:method
